export const LAYOUT_SEGMENTS = {
  ROOT: '',
  AUTH: 'auth',
  GAME: 'game',
  GAME_PLAY: 'play',
  DOWNLOAD: 'download',
  PROFILE: 'profile',
  PROFILE_FRIENDS: 'friends',
  PROFILE_LIBRARY: 'my-library',
  REDEEM_GAME_PROMO_CODES: 'redeem',
  REFERRAL_GAME_DOWNLOAD: 'referral',
} as const;
